import { render, staticRenderFns } from "./ReceivedDaysInsurer.vue?vue&type=template&id=5eaf2b5e"
import script from "./ReceivedDaysInsurer.vue?vue&type=script&lang=js"
export * from "./ReceivedDaysInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports